var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'tw-relative xl:tw-absolute xl:tw-w-[263px] tw-w-full tw-mt-3 xl:tw-mt-0': !_vm.isOnboardingRedesign},style:([
    _vm.$_breakpoint_xl && {
      bottom: `${_vm.bottom}px`,
      left: `${_vm.left}px`
    }
  ])},[(_vm.isOnboardingRedesign)?[_c('p',{staticClass:"tw-text-xl tw-mb-2"},[_vm._v(" Please ensure: ")])]:[_c('p',{staticClass:"label-header"},[_vm._v(" Ensure that: ")])],_vm._l((_vm.items),function(item){return _c('p',{key:item,staticClass:"mb-0"},[_vm._v(" - "+_vm._s(item)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }